import { url_add_param, get_sale_campaign_params } from '../../util/methods';

$(document).on('turbolinks:load', function () {

  // The following code will add existing sale and/or sale_campaign filters when sending a product search
  $('form.header-category-search-form').on('submit', function(e){
    var $this = $(this);
    var sale_campaign_params = get_sale_campaign_params();

    if (sale_campaign_params['on_sale'] === 'true') {
      e.preventDefault();

      // Get the current action URL of the form 
      var actionURL = $this.attr('action');

      // Serialize the form data 
      var formData = $this.serialize();

      // Combine the serialized form data with the action URL
      var fullURL = actionURL + '?' + formData; 
      
      // Add sale-related params to URL
      for (const param in sale_campaign_params) {
        if (sale_campaign_params[param]) {
          var fullURL = url_add_param(fullURL, param, sale_campaign_params[param]);
        }
      }

      // Navigate to the full URL 
      location.href = fullURL;
    }
  })
  
});